<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="应用名称">
          <a-input placeholder="请输入应用名称" v-decorator="[ 'appName', validatorRules.appName]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="盘号">
          <a-input placeholder="请输入盘号" v-decorator="[ 'appSsid', validatorRules.appSsid]"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="包名">
          <a-input placeholder="请输入包名" v-decorator="[ 'appPackageName', validatorRules.appPackageName]"/>
        </a-form-item>

         <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="logo">
          <a-input placeholder="请输入logo" v-decorator="[ 'logoUrl' ]"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="子产品遮罩层">
          <a-input placeholder="请输入子产品遮罩层" v-decorator="[ 'showUrl' ]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="停用标识">
          <a-select placeholder="请选择" v-decorator="[ 'delFlag', { initialValue: '0' } ]">
            <a-select-option value="0">
              启用
            </a-select-option>
            <a-select-option value="1">
              停用
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="APP版本">
          <a-input placeholder="请输入APP版本" v-decorator="[ 'appVersion' ]"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="APP下载地址">
          <a-input placeholder="请输入APP下载地址" v-decorator="[ 'appDownUrl' ]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="强制更新标识">
          <a-select placeholder="请选择" v-decorator="[ 'forceUpdateFlag', { initialValue: null } ]"
            style="width: 100%;">
            <a-select-option :value="null">&nbsp;</a-select-option>
            <a-select-option value="0">
              是
            </a-select-option>
            <a-select-option value="1">
              否
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="更新提示信息">
          <a-input placeholder="请输入更新提示信息" v-decorator="[ 'promptMsg' ]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="类型">
          <a-select placeholder="请选择" v-decorator="[ 'sourceType', { initialValue: null } ]"
            style="width: 100%;">
            <a-select-option :value="null">&nbsp;</a-select-option>
            <a-select-option value="apk-black">
              apk-black
            </a-select-option>
            <a-select-option value="ios">
              ios
            </a-select-option>
            <a-select-option value="risk">
              risk
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="催收类型">
          <dict-select
              v-decorator="[ 'collectorType', { initialValue: '' } ]"
              :dict-code="DICT_CODE.COLLECTOR_TYPE"
              :placeholder="$t('select')"
              fieldKey="label"
            />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="是否推荐产品">
          <a-select placeholder="请选择" v-decorator="[ 'vipProductViewFlag', { initialValue: '0' } ]">
            <a-select-option value="1">
              是
            </a-select-option>
            <a-select-option value="0">
              否
            </a-select-option>
          </a-select>
        </a-form-item>

        <!-- <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="主产品">
          <a-input placeholder="请输入主产品id" v-decorator="[ 'parentId' ]"/>
        </a-form-item> -->

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="开启配置">
          <a-input placeholder="请输入" v-decorator="[ 'mulFlag' ]"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="JSON文本转换类">
          <a-input placeholder="请输入" v-decorator="[ 'jsonBeanName' ]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="是否展示">
          <a-select placeholder="请选择" v-decorator="[ 'gpStatus', { initialValue: '0' } ]">
            <a-select-option value="1">
              是
            </a-select-option>
            <a-select-option value="0">
              否
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="是否上架">
          <a-select placeholder="请选择" v-decorator="[ 'pageViewFlag', { initialValue: '0' } ]">
            <a-select-option value="1">
              是
            </a-select-option>
            <a-select-option value="0">
              否
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="推荐产品下载地址">
          <a-input placeholder="请输入推荐产品下载地址" v-decorator="[ 'imageViewFlag' ]"/>
        </a-form-item>

      </a-form>
      <div style="display: flex; justify-content: flex-end; margin-top: 8px;">
        <span style="color: tomato; font-size: 12px;">应用数据存在缓存，五分钟后生效</span>
    </div>
    </a-spin>
  </a-modal>
</template>
<script>
import pick from 'lodash.pick'
import { addApp, editApp,uploadImage } from '@/webpublicapi/system'
import DictSelect from '../../modules/DictSelect';


// duplicateCheck
export default {
  name: 'AppModal',
  components: {
    DictSelect,
  },
  mounted(){

    if(typeof FileReader=='undifined')        {
      console.log('抱歉，你的浏览器不支持 FileReader');
    }else{
      console.log('FileReader');
    }
  },
  data () {
    return {
      value: 1,
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        appName: { rules: [{ required: true, message: '请输入应用名称!' }] },
        appSsid: { rules: [{ required: true, message: '请输入盘号!' }] },
        appPackageName: { rules: [{ required: true, message: '请输入包名!' }] }
      }
    }
  },
  created () {
  },
  methods: {
    add () {
      this.edit({})
    },
    edit (record) {
      if (record.id) {
        this.visiblekey = true
      } else {
        this.visiblekey = false
      }
      this.form.resetFields()
      this.model = Object.assign({}, record)
      if (this.model.collectorType !== undefined && this.model.collectorType !== null) {
        this.model.collectorType = String(this.model.collectorType)
      }
      if (this.model.delFlag !== undefined) {
        this.model.delFlag = String(this.model.delFlag)
      }
      if (this.model.vipProductViewFlag !== undefined) {
        this.model.vipProductViewFlag = String(this.model.vipProductViewFlag)
      }
      if (this.model.gpStatus !== undefined) {
        this.model.gpStatus = String(this.model.gpStatus)
      }
      if (this.model.pageViewFlag !== undefined) {
        this.model.pageViewFlag = String(this.model.pageViewFlag)
      }
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'appName', 'appSsid', 'appPackageName', 'logoUrl', 
        'showUrl', 'delFlag', 'appVersion', 'appDownUrl', 'forceUpdateFlag', 'promptMsg', 'sourceType', 
        'collectorType', 'vipProductViewFlag', 'parentId', 'mulFlag', 'jsonBeanName', 'gpStatus', 'pageViewFlag',
        'imageViewFlag'
        ))
      })
    },
    // 确定
    handleOk () {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          let obj
          console.log(formData)
          if (!this.model.id) {
            obj = addApp(formData)
          } else {
             obj = editApp(formData)
          }
          obj.then((res) => {
            if (res.code === 1000) {
              this.$message.success(res.msg)
              this.$emit('ok')
            } else {
              this.$message.warning(res.msg)
            }
          }).finally(() => {
            this.confirmLoading = false
            this.close()
          })
        }
      })
    },
    // 关闭
    handleCancel () {
      this.close()
    },

    close () {
      this.$emit('close')
      this.visible = false
    },
    selectLoadImg() {
      this.$refs.avatarInput.dispatchEvent(new MouseEvent("click"));
    },
    changeImage() {
      let files = this.$refs.avatarInput.files;
      let that = this;
      function readAndPreview(file) {
        that.file = file
        if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
          let reader = new FileReader();
          reader.onload = function() {
            if (that.imgData !== this.result) {
              that.imgData = this.result // 这个是base64的数据格式
            }
          };
          reader.readAsDataURL(file);
        }
      }

      if (files) {
        [].forEach.call(files, readAndPreview);
      }
    },
    upLoad() {
      let imgFile = this.file;//获取到上传的图片
      let formData = new FormData();//通过formdata上传
      formData.append('file', imgFile)
      this.axios({
        method: "post",
        url: "/web/app/upload",
        data: formData,
        core: true
      })
        .then((res) => {
          console.log(res.data);
          alert("上传成功! 地址为:"+res.data)
          this.form.setFieldsValue({
            logoUrl: res.data
          })
        })
        .catch((error) => {
          console.log(error);
        })

    },
  }
}
</script>
